import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';

import { Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { myWalletInteractionClick } from 'reaxl-analytics-handlers';
import {
    ContentPreview,
    InventoryImage,
    Pricing,
} from 'reaxl-molecules';
import { PaymentSnapshot } from 'reaxl-wallet';

import offsetCalc from '@/utilities/offSetScrollCalculation';
import scrollToElement from '@/utilities/scrollToElement';

import { listingPaymentCTAClick } from '@/analytics/inventoryPaymentsEvents';

import dealsDuck from '@/ducks/dealsDuck.js';
import paymentsDuck from '@/ducks/paymentsDuck.js';

function InventoryPaymentSnapshot({
    existingDeal,
    hidePaymentSnapshot = false,
    isWalletPaymentOptionEnabled,
    listing,
    showPayment,
    showPaymentCTA,
}) {
    const dispatch = useDispatch();
    const leasePaymentResponse = useSelector((state) => paymentsDuck?.selectors?.getLowestLeasePaymentByListingId(state, listing?.id));
    const paymentEmphasis = useSelector((state) => paymentsDuck?.selectors?.getMyWalletInteraction(state, 'paymentEmphasis'));
    const paymentOption = useSelector(paymentsDuck?.selectors?.getPaymentOption) || 'finance';
    const pencilingPayment = useSelector((state) => paymentsDuck?.selectors?.getLowestPencilingPaymentByListingId(state, listing?.id));
    const paymentsInfo = useSelector(paymentsDuck?.selectors?.getPaymentsInfo) || {};

    const {
        id: inventoryId,
        listingTitle,
        pricingDetail = {},
        title,
    } = listing;
    const primary = _get(listing, ['images', 'primary'], 0);
    const image = _get(listing, `images.sources[${primary}].src`, '');

    const handleWalletPricingDetailsClick = useCallback((event) => {
        event.stopPropagation();

        const offset = offsetCalc(25, 'sticky-header-vdp');
        scrollToElement('nds', offset);
        sendClick(listingPaymentCTAClick, event, { inventoryId, placement: 'sticky-header' });
        sendClick(myWalletInteractionClick, event, { paymentsDuck });
    }, [inventoryId]);

    const handlePaymentCTAClick = useCallback((event) => {
        event.stopPropagation();
        dispatch(paymentsDuck.creators.updateMyWallet({
            displayModal: true,
        }));
        sendClick(listingPaymentCTAClick, event, { inventoryId, placement: 'sticky-header' });
        sendClick(myWalletInteractionClick, event, { paymentsDuck });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inventoryId]);

    const paymentCardCTAProps = {
        dealsDuck,
        existingDeal,
        leasePaymentResponse,
        paymentEmphasis,
        paymentOption,
        paymentsInfo,
        pencilingPayment,
    };

    return (
        <ContentPreview
            key="inventory-payment-snapshot"
            image={(
                <InventoryImage
                    className="rounded"
                    src={image}
                    sizes={{
                        height: 40,
                        width: 55,
                    }}
                />
            )}
            contentClassName="margin-right-3"
            mediaClassName="align-self-center"
            headline={(
                <Text size={300}>{listingTitle || title}</Text>
            )}
            summary={(
                <Pricing
                    uiContext="compact"
                    data={pricingDetail}
                    walletCTA={!hidePaymentSnapshot && (
                        <PaymentSnapshot
                            isWalletPaymentOptionEnabled={isWalletPaymentOptionEnabled}
                            listing={listing}
                            onMyWalletClick={handleWalletPricingDetailsClick}
                            onPaymentCTAClick={handlePaymentCTAClick}
                            paymentCardCTAProps={paymentCardCTAProps}
                            showPayment={showPayment}
                            showPaymentCTA={showPaymentCTA}
                            uiContext="compact"
                        />
                    )}
                />
            )}
        />
    );
}

export default InventoryPaymentSnapshot;
